import { render } from "./DialogPopup.vue?vue&type=template&id=008706ab"
import script from "./DialogPopup.vue?vue&type=script&lang=js"
export * from "./DialogPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__